<template>
	<div class="SNMedicalWidget">
		<div class="row">
			<div class="col-xs-12">
				<panel-basic :title="field.FIELD_LABEL"
					:helpText="field.DISTRICT_HELP_TEXT"
					:collapsable="true"
					id="panel"
					class="rounded-top"
					panel-class="full-height"
					style="border-radius: 25px;"
				>
					<template v-if="field.FIELD_FILE_URL">
						<div style="margin-top:-15px;">
							{{ displayText.attachmentWithColon }}  <a :href="field.FIELD_FILE_URL" target="_blank">{{ field.FIELD_DOC_FILENAME }}</a>
						</div>
						<br />
					</template>
					<div class="row">
						<div class="col-xs-12 col-md-12" v-if="isValidDateForm">
							<template v-if="(formAction !== 'normal' && !!existingAbsenceDate) || (!!formData.CHECKED_DATES && formData.CHECKED_DATES.length > 0)">
								<label>{{ displayText.selectDates }} <span style="color: red;">*</span></label>
								<ul class="list-group" style="max-height:400px;overflow-y:auto;border:1px solid #ccc;">
									<li
										class="list-group-item"
										v-for="(attend, index) in formData.STUDENT_UNEXCUSED_DAYS"
										:key="attend.DATE"
									>
										<input
											type="checkbox"
											name="existingDays"
											:id="`date_${index}`"
											:value="attend.DATE"
											v-model="formData.CHECKED_DATES"
											:disabled="isReadOnly || isLastOneChecked( attend.DATE )"
										>
										<label style="font-weight:normal;" :for="`date_${index}`">{{attend.DATE}} {{attend.ATTENDANCE_CODE}} - {{attend.ATTENDANCE_CODE_DESC}}</label>
									</li>
								</ul>
							</template>
							<template v-else-if="allowRange">
								<div class="col-md-6 col-xs-12" style="margin-left:-15px;">
									<label>
										{{ displayText.absenceDateFrom }}<span style="color: red;">*</span>
									</label>
									<ValidationProvider
										ref="provider"
										rules="required"
										v-slot="{ errors }"
									>
										<date-picker
											:id="`attendanceWidgetDate`"
											:name="`attendanceWidgetDate`"
											lang="en"
											style="display: contents;"
											format="MM/DD/YYYY"
											v-model="formData.DATE_FROM"
											:clearable="false"
											:disabled-days="disabledDate"
											:disabled="isReadOnly"
											:not-before="disabledBefore"
    									:not-after="disabledAfter"
											fixed-position="bottom-right"
										>
										</date-picker>
										<span class="text-danger" v-if="errors.length">
											{{ errors[0].replace( '{field}', 'Absence Date' ) }}
										</span>
									</ValidationProvider>
								</div>
								<div class="col-md-6 col-xs-12">
									<div class="row">
										<div class="col-xs-12 col-md-6"></div>
									</div>
									<label>
										{{ displayText.absenceDateTo }}<span style="color: red;">*</span>
									</label>
									<ValidationProvider ref="provider" rules="required" v-slot="{ errors }">
										<date-picker
											:id="`attendanceWidgetDate2`"
											:name="`attendanceWidgetDate2`"
											lang="en"
											style="display: contents;"
											format="MM/DD/YYYY"
											ref="dateToPicker"
											v-model="formData.DATE_TO"
											:clearable="false"
											:disabled-days="disabledDate2"
											:disabled="isReadOnly"
											:not-before="disabledBefore"
    									:not-after="disabledAfter"
											fixed-position="bottom-right"
											@change="setCorrectDate()"
										>
										</date-picker>
										<p class="text-danger" v-if="errors.length">
											{{ errors[0].replace( '{field}', 'Absence Date' ) }}
										</p>
									</ValidationProvider>
								</div>
								<br />
							</template>
							<template v-else>
								<label>{{ displayText.absenceDate }} <span style="color: red;">*</span></label>
								<ValidationProvider ref="provider" rules="required" v-slot="{ errors }">
									<date-picker
										:id="`attendanceWidgetDate`"
										:name="`attendanceWidgetDate`"
										lang="en"
										style="display: contents;"
										format="MM/DD/YYYY"
										v-model="formData.DATE"
										:clearable="false"
										:disabled-days="disabledDate"
										:disabled="isReadOnly"
										:not-before="disabledBefore"
    								:not-after="disabledAfter"
									>
									</date-picker>
									<p class="text-danger">{{ errors[0] }}</p>
								</ValidationProvider>
							</template>
							<p class="info" v-if="(!formData.CHECKED_DATES || formData.CHECKED_DATES.length === 0) && !field.WIDGET_OPTIONS.WID_ALLOW_HISTORIC_DATES_FLG || field.WIDGET_OPTIONS.WID_ALLOW_HISTORIC_DATES_FLG !== 'Y'">
								{{ displayText.attendanceDateMessage }}
							</p>
							<br />
							<div class="row">
								<div class="col-xs-12">
									<ValidationProvider ref="provider" rules="required" v-slot="{ errors }">
										<label>{{ displayText.absenceReason }} <span style="color: red;">*</span></label>
										<textarea class="form-control"
											:name="`attendanceWidgetReason`"
											:id="`attendanceWidgetReason`"
											v-model="formData.ATTENDANCE_REASON"
											:disabled="isReadOnly"
										>
										</textarea>
										<span class="text-danger" v-if="errors.length">
											{{ errors[0].replace('{field}','Reason for Absence') }}
										</span>
										<br/>
										<br/>
									</ValidationProvider>
								</div>
							</div>
							<label>
								{{ displayText.attachDocuments }}<span v-if="!!field.WIDGET_OPTIONS.WID_REQUIRE_FILEUPLOAD_FLG && field.WIDGET_OPTIONS.WID_REQUIRE_FILEUPLOAD_FLG === 'Y'" style="color: red;">*</span>
							</label>
							<div class="dropzone-area" v-if="loadedFilePickerData && !isReadOnly" @mousedown="doFetchToken">
								<file-uploader ref="fileUpload"
									:inputId="`fileUpload_${field.FIELD_ID}`"
									:size="52428800"
									:multiple="true"
									:files="tempFiles"
									:URL="externalFileData"
									:postAction="`/PortalAPI/index.cfm/api/v1/data-verification-forms/field-files?dv_form_id=${field.DV_FORM_ID}&field_id=${field.FIELD_ID}&instance_id=${instanceID}&student_rid=${selectedStudent.STUDENT_RID}`"
									:auth="{
										'Authorization': accessToken,
										'Client-ID': clientID
									}"
									@updateFiles="updateFiles($event, field.FIELD_ID)"
									@saveGoogleFilesData="saveGoogleFilesData(file=$event, multiple=true, field.FIELD_ID)"
									@saveDropboxFilesData="saveDropboxFilesData(file=$event, multiple=true, field.FIELD_ID)"
									@saveOneDriveFilesData="saveOneDriveFilesData(file=$event, multiple=true, field.FIELD_ID)"
								>
								</file-uploader>
							</div>
							<div class="row">
								<div class="col-xs-12">
									<p>
										<strong>
											{{ displayText.uploadFilesTitleCase }}
										</strong>
									</p>
								</div>
							</div>
							<ul class="list-group">
								<li class="list-group-item" v-for="(file, index) in formValues.DATA.FILES" :key="file.HASHA + file.FILE_IDX">
									<div class="row">
										<div class="col-xs-11">
											<a :href="file.FILE_URL" target="_blank">{{file.DV_FILE_NAME}}</a>
										</div>
										<div class="col-xs-1 text-right">
											<a href="#"
												@click.prevent="deleteFile(file.DV_FORM_ID, file.FIELD_ID, file.FILE_IDX, file.INSTANCE_ID, file.STUDENT_RID, index)"
											>
												<span class="label label-danger">
													<font-awesome-icon icon="times" />
												</span>
											</a>
										</div>
									</div>
								</li>
							</ul>
							<pre style="height:200px;overflow:scroll;" v-if="debug">
								{{ JSON.stringify(formValues, null, 2) }}
							</pre>
						</div>
						<div class="alert alert-danger" v-else>
							{{ displayText.attendanceNoDatesMessage }}
						</div>
					</div>
				</panel-basic>
			</div>
		</div>
	</div>
</template>

<script>
	import PanelBasic from '../panels/PanelBasic.vue';
	import DatePicker from '../shared/DatePicker.vue';
	import { ValidationProvider, Validator  } from 'vee-validate';
	import moment from 'moment';
	import FileUploader from '../shared/FileUploader.vue';

	export default {
		name: 'SISAttendanceWidget',
		props: {
			formData: {
				type: Object,
				required: true
			},
			formValues: {
				type: Object,
				required: true
			},
			selectedStudent: {
				type: Object,
				required: true
			},
			field: {
				type: Object,
				required: true
			},
			accessToken: {
				type: String,
				required: true
			},
			clientID: {
				type: String,
				required: true
			},
			instanceID: {
				type: String | Number,
				required: true
			},
			loadedFilePickerData: {
				type: Boolean,
				required: true,
				default: false
			},
			externalFileData:{
				type: Object,
				required: true
			},
			disabledDates: {
				type: Array,
				default: []
			},
			isReadOnly: {
				type: Boolean,
				default: false
			},
			updatedText: {
				type: Object,
				default: () => {}
			},
		},
		data() {
			return {
				disabledBefore: moment('1800-01-01'),
				disabledAfter: moment('9999-12-31'),
				tempFiles:[],
				debug: false,
				formAction:"normal",
				existingAbsenceDate:'',
				displayText: {
					attachmentWithColon: "Attachment:",
					absenceDateFrom: "Absence Date From",
					absenceDate: "absenceDate",
					attendanceDateMessage: "Dates must be greater or equal to today.",
					absenceReason: "Reason for Absence",
					attachDocuments: "Attach Documents",
					uploadFilesTitleCase: "Uploaded Files",
					attendanceNoDatesMessage: "No Valid Dates Available in Form - School year end date is in the past and this form does not allow past dates..",
					absenceDateTo: "Absence Date To",
					selectDates: "Select the dates that apply"
				},
			};
		},
		computed: {
			allowRange() {
				return !!this.field.WIDGET_OPTIONS.WID_DATE_SETTING && this.field.WIDGET_OPTIONS.WID_DATE_SETTING === "RANGE";
			},
			isValidDateForm() {
				/* if we dont allow historic dates and not existing absence mode */
				if(!this.isReadOnly && !((this.formAction !== 'normal' && !!this.existingAbsenceDate) || (!!this.formData.CHECKED_DATES && this.formData.CHECKED_DATES.length > 0))){
					if( !this.field.WIDGET_OPTIONS.WID_ALLOW_HISTORIC_DATES_FLG || this.field.WIDGET_OPTIONS.WID_ALLOW_HISTORIC_DATES_FLG !== "Y" ) {
						if( !!this.formData.SCHOOL_END_DATE ) {
							let end = moment( this.formData.SCHOOL_END_DATE );

							if( moment() > end ) {
								return false;
							}
						}
					}
				}

				return true;
			}
		},
		watch: {
			formData: {
				handler( newValue, oldValue ) {
					if( this.field.WIDGET_OPTIONS.WID_ALLOW_HISTORIC_DATES_FLG !== "Y" && !this.isReadOnly ) {
						if( moment.isMoment( moment( newValue.DATE_TO ) ) && !isNaN( moment( newValue.DATE_TO ) ) && moment( newValue.DATE_TO ) < moment() ) {
							newValue.DATE_TO = moment();
						}

						if( moment.isMoment( moment( newValue.DATE ) ) && !isNaN( moment( newValue.DATE ) ) && moment( newValue.DATE ) < moment() ) {
							newValue.DATE = moment();
						}
					}

					if( moment( newValue.DATE_TO ) < moment( newValue.DATE_FROM ) ) {
						newValue.DATE_TO = newValue.DATE_FROM;
					}


					const sqlServerMinDate = moment('1800-01-01');
					const sqlServerMaxDate = moment('9999-12-31');

					if(moment( newValue.DATE_TO ) > sqlServerMaxDate){
						newValue.DATE_TO = sqlServerMaxDate
					}
					if(moment( newValue.DATE_TO ) < sqlServerMinDate){
						newValue.DATE_TO = sqlServerMinDate;
					}

					if(moment( newValue.DATE_FROM ) > sqlServerMaxDate){
						newValue.DATE_FROM = sqlServerMaxDate
					}
					if(moment( newValue.DATE_FROM ) < sqlServerMinDate){
						newValue.DATE_FROM = sqlServerMinDate;
					}

					if(moment( newValue.DATE_FROM ) > sqlServerMaxDate){
						newValue.DATE_FROM = sqlServerMaxDate
					}
					if(moment( newValue.DATE_FROM ) < sqlServerMinDate){
						newValue.DATE_FROM = sqlServerMinDate;
					}

				},
				deep: true,
			},
		},
		methods: {
			setCorrectDate() {
				/*
					Only used in the date range picker setup and will only work when start date is after end date
					Triggers only on the change in the End Date picker input
				*/
				if(
					moment( this.formData.DATE_FROM ).format( "MM/DD/YYYY" ) >
					moment( this.formData.DATE_TO ).format( "MM/DD/YYYY" )
				) {
					this.formData.DATE_TO = moment( this.formData.DATE_FROM ).format( "MM/DD/YYYY" );
					// The userInput is necessary for changing what is shown to the updated date
					this.$refs.dateToPicker.userInput = this.formData.DATE_TO;
				}
			},
			isLastOneChecked( date ) {
				return this.formData.CHECKED_DATES.length === 1 &&
					this.formData.CHECKED_DATES.includes( date );
			},
			updateFiles(event, fieldId) {
				this.tempFiles = event;
				for(let i = ( event.length - 1 ); i >= 0; i-- ){
					let itm = event[ i ];
					if( !!itm.success && itm.success && !!itm.response.data) {
						this.$emit("updateFiles2", event, fieldId);
					}
				}
			},
			saveGoogleFilesData( event, multiple, fieldId ) {
				this.$emit("saveGoogleFilesData2",  event, multiple, fieldId );
			},
			saveDropboxFilesData( event, multiple, fieldId ) {
				this.$emit("saveDropboxFilesData2", event, multiple, fieldId );
			},
			saveOneDriveFilesData( event, multiple, fieldId ) {
				this.$emit("saveOneDriveFilesData2", event, multiple, fieldId );
			},
			deleteFile( formId, fieldId, fileIdx, instanceId, studentRid, index ) {
				this.$emit("deleteFile2", formId, fieldId, fileIdx, instanceId, studentRid, index );
			},
			doFetchToken() {
				this.$emit("doFetchToken");
			},
			validateDate( date ) {
				let today = moment();
				today.set( "hour", 0 );
				today.set( "minute", 0 );
				today.set( "second", 0 );
				today.set( "millisecond", 0 );

				// if the field is empty
				if( !date || date.length === 0) {
					return false;
				}

				/* if we dont allow historic dates */
				if( ( !this.field.WIDGET_OPTIONS.WID_ALLOW_HISTORIC_DATES_FLG || this.field.WIDGET_OPTIONS.WID_ALLOW_HISTORIC_DATES_FLG !== "Y" ) && moment ( date ) < today ) {
					return false;
				}

				if( !!this.formData.SCHOOL_START_DATE && !!this.formData.SCHOOL_END_DATE ) {
					let start = moment( this.formData.SCHOOL_START_DATE );
					let end = moment( this.formData.SCHOOL_END_DATE );
					if( moment( date ) > end || moment( date ) < start ) {
						return false;
					}
				}

				if( !!this.formData.STUDENT_ATTEND_DAYS && this.formData.STUDENT_ATTEND_DAYS.length > 0 ) {
					let filtered = this.formData.STUDENT_ATTEND_DAYS.filter( itm => {
						itm = moment( itm );
						itm.set( "hour", 0 );
						itm.set( "minute", 0 );
						itm.set( "second", 0 );
						itm.set( "millisecond", 0 );
						return itm._d === moment( date )._d;
					} );

					if( filtered.length > 0 ) {
						return false;
					}
				}

				// All is good
				return true;
			},
			disabledDate( date ) {
				if( !this.validateDate( date ) ) {
					return true;
				}

				return false;
			},
			disabledDate2( date ) {
				return moment( date ) < moment( this.formData.DATE_FROM ) || !this.validateDate( date );
			},
			updateTextDisplayed() {
				// Check what values exists in the updatedText prop and update the displayText
				if( !!this.updatedText.attachmentWithColon ) {
					this.displayText.attachmentWithColon = this.updatedText.attachmentWithColon;
				}

				if( !!this.updatedText.absenceDateFrom ) {
					this.displayText.absenceDateFrom = this.updatedText.absenceDateFrom;
				}

				if( !!this.updatedText.absenceDate ) {
					this.displayText.absenceDate = this.updatedText.absenceDate;
				}

				if( !!this.updatedText.attendanceDateMessage ) {
					this.displayText.attendanceDateMessage = this.updatedText.attendanceDateMessage;
				}

				if( !!this.updatedText.absenceReason ) {
					this.displayText.absenceReason = this.updatedText.absenceReason;
				}

				if( !!this.updatedText.attachDocuments ) {
					this.displayText.attachDocuments = this.updatedText.attachDocuments;
				}

				if( !!this.updatedText.uploadFilesTitleCase ) {
					this.displayText.uploadFilesTitleCase = this.updatedText.uploadFilesTitleCase;
				}

				if( !!this.updatedText.attendanceNoDatesMessage ) {
					this.displayText.attendanceNoDatesMessage = this.updatedText.attendanceNoDatesMessage;
				}

				if( !!this.updatedText.absenceDateTo ) {
					this.displayText.absenceDateTo = this.updatedText.absenceDateTo;
				}

				if( !!this.updatedText.selectDates ) {
					this.displayText.selectDates = this.updatedText.selectDates;
				}
			}
		},
		beforeMount() {
			this.updateTextDisplayed();
		},
		mounted() {
			/* if routed from attendance screen */
			if(!!this.$route.params && !!this.$route.params.formAction && !!this.$route.params.attendanceDate){
				this.formAction = this.$route.params.formAction;
				this.existingAbsenceDate = this.$route.params.attendanceDate;
				this.formData.CHECKED_DATES.push(this.$route.params.attendanceDate);
			}
			/* If opened existing form */
			else if(!!this.formData.CHECKED_DATES && this.formData.CHECKED_DATES.length > 0){
				this.formAction = 'submitExisting';
				this.existingAbsenceDate = this.formData.CHECKED_DATES[0];
			}
		},
		beforeRouteLeave( to, from, next ) {
			if(to.name === "OnDemandForm" && !!this.$route.params.attendanceDate) {
				to.params.attendanceDate = this.$route.params.attendanceDate;
				to.params.formAction = "submitExisting";
			}

			next();
		},
		components: {
			PanelBasic,
			ValidationProvider,
			DatePicker,
			FileUploader
		}
	}
</script>
